/* eslint-disable */

export const enum BulkEmailJobStatus {
  queued = 0,
  sent = 1,
  sentConfirmed = 2,
  failed = 3,
}
